<template>
  <div>
    <v-row>
      <v-col>
        <BaseTitle pageTitle="GESTÃO DE PROCESSOS " />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <Tabs :tabs="allTabs" :onChangeTab="onChangeTab" v-model="currentTab">
          <template v-slot:todos_os_processos>
            <todosOsProcessos :loading="loading" />
          </template>
          <template v-slot:prestação_de_contas>
            <prestacaoContas :loading="loading" :currentTab="currentTab"/>
          </template>
          <template v-slot:prestação_de_contas_retornado>
            <prestacaoContas :loading="loading" :currentTab="currentTab" />
          </template>
          <template v-slot:anexo_da_nota_fiscal_retornado>
            <anexoNotaFiscal :loading="loading" :currentTab="currentTab"/>
          </template>
          <template v-slot:pagamentos>
            <pagamentos :loading="loading" />
          </template>
          <template v-slot:finalizados>
            <finalizados :loading="loading" />
          </template>
          <template v-slot:anexo_da_nota_fiscal>
            <anexoNotaFiscal :loading="loading" :currentTab="currentTab"/>
          </template>
        </Tabs>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseTitle from "../../components/UI/BaseTitle";
import Tabs from "../../components/UI/Tabs";
import prestacaoContas from "./_components/prestacaoContas";
import anexoNotaFiscal from "./_components/anexoNotaFiscal";
import pagamentos from "./_components/pagamentos";
import finalizados from "./_components/finalizados";
import todosOsProcessos from "./_components/todosOsProcessos";
import { VMoney } from "v-money";
import { mapGetters, mapActions } from "vuex";
// import store from "./_store";
import { mask } from "vue-the-mask";
import JWT from "../../api/jwt";
import _ from "lodash";

export default {
  components: {
    BaseTitle,
    prestacaoContas,
    anexoNotaFiscal,
    pagamentos,
    finalizados,
    todosOsProcessos,
    Tabs
  },
  directives: { money: VMoney, mask },
  data() {
    return {
      page: 1,
      pagePendencia: 1,
      processosPendentes: [],
      loading: true,
      filters: {},
      menu: false,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false /* doesn't work with directive */
      },
      isFilterAdvanced: false,
      headers: [
        {
          value: "actions",
          actions: [
            {
              type: "button",
              click: "onView",
              icon: "icon-eye",
              options: { fab: true, icon: true, small: true }
            }
          ]
        },
        { text: "Nº do processo", value: "cd_processo" },
        { text: "Cód. Fornecimento", value: "nm_codigo_fornecimento" },
        { text: "Tipo do processo", value: "tipo_processo.nm_tipo_processo" },
        {
          text: "Valor da solicitação",
          value: "valor"
        },
        { text: "Data de Previsão de Pagamento", value: "" },
        { text: "Status", value: "status" }
      ],
      pendingHeaders: [
        {
          value: "actions",
          actions: [
            {
              type: "button",
              click: "onEdit",
              icon: "icon-pencil",
              hide: () => this.view,
              options: { fab: true, icon: true, small: true }
            },
            {
              type: "button",
              click: "onView",
              icon: "icon-eye",
              options: { fab: true, icon: true, small: true }
            }
          ]
        },
        { text: "Nº do processo", value: "cd_processo" },
        { text: "Cód. Fornecimento", value: "nm_codigo_fornecimento" },
        { text: "Tipo do processo", value: "tipo_processo.nm_tipo_processo" },
        {
          text: "Valor da solicitação",
          value: "valor"
        },
        { text: "Data de Previsão de Pagamento", value: "" },
        { text: "Status", value: "status" }
      ],
      currentTab: "prestação_de_contas",
      allTabs: [
        {
          name: "Prestação de contas",
          show: true
        },
        {
          name: "Prestação de contas retornado"
        },
        {
          name: "Anexo da nota fiscal"
        },
        {
          name: "Anexo da nota fiscal retornado"
        },
        {
          name: "Pagamentos"
        },
        {
          name: "Finalizados"
        },
        {
          name: "Todos os processos"
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      processes: "$_process/processes",
      processTypes: "$_process/processTypes",
      processStatus: "$_process/processStatus",
      departaments: "$_process/departaments",
      me: "$_auth/me"
    }),
    // processosPendentes() {
    //   const processos = this.processes.processosPendentes || [];
    //   return processos.slice(
    //     (this.pagePendencia - 1) * 10,
    //     this.pagePendencia * 10
    //   );
    // },
    view() {
      return this.$can("edit");
    }
  },

  watch: {
    processes: {
      handler(val) {
        const processos = val.processosPendentes || [];
        this.processosPendentes = processos.slice(
          (this.pagePendencia - 1) * 10,
          this.pagePendencia * 10
        );
      },
      deep: true
    }
  },

  // beforeCreate() {
  //   const STORE_AUTH = "$_process";

  //   if (!(STORE_AUTH in this.$store._modules.root._children))
  //     this.$store.registerModule(STORE_AUTH, store);
  // },

  async created() {
    await this.getProcess();
    await this.getProcessTypes();
    await this.getProcessStatus();
    await this.getDepartaments();
  },

  methods: {
    async onChangeTab() {
      this.$route.query.search = "";
      await this.getProcess();
    },
    async redirectGFS(item, type) {
      if (!_.hasIn(this.me, "tokenGfs")) {
        await this.$store.dispatch(`$_messages/setErrors`, {
          message: `Não foi possível acessar o processo no momento. Por favor, tente novamente.`,
          type: "error",
          title: "Error!",
          timeout: 8000
        });
        return false;
      }

      if (type === "edit") {
        let url = `${process.env.VUE_APP_GFS_URL}processos/${
          item.cd_processo
        }/editar?token_pfo=${JWT.getToken()}&token_gfs=${
          this.me.tokenGfs
        }&back=${this.$route.path.slice(1)}`;
        window.location.replace(url);
      } else {
        let url = `${process.env.VUE_APP_GFS_URL}processos/${
          item.cd_processo
        }/visualizar?token_pfo=${JWT.getToken()}&token_gfs=${
          this.me.tokenGfs
        }&back=${this.$route.path.slice(1)}`;
        window.location.replace(url);
      }
    },
    async handlerUniversalFilter() {
      let newFilter = {};
      Object.entries(this.filters).forEach(element => {
        if (element[1]) {
          newFilter[element[0]] = element[1];
        }
      });

      await this.$router.replace({ name: "process.index", query: newFilter });
      await this.getProcess();
    },
    async getProcess(page) {
      let currentTab = this.currentTab;

      if (this.currentTab.includes("prestação")) {
        // change only the word "prestação" to "prestacao" on string currentTab
        currentTab = this.currentTab.replace("prestação", "prestacao");
      }

      this.page = page || 1;
      this.loading = true;

      await this.listProvider({
        ...this.$route.query,
        page: this.page,
        type: currentTab
      });

      this.loading = false;
    },
    async handlerSearch() {
      let newFilter = {};
      Object.entries(this.filters).forEach(element => {
        if (element[1]) {
          newFilter[element[0]] = element[1];
        }
      });

      await this.$router.replace({ name: "process.index", query: newFilter });
      await this.getProcess();
    },
    async handlerErase() {
      Object.entries(this.filters).forEach(element => {
        this.filters[element[0]] = "";
      });

      await this.$router.replace({ name: "process.index" });
      await this.getProcess();
    },

    setRowClass(item) {
      switch (
        item.historico_processo_descendente[0].processos_situacao.situacao.situacao.toLowerCase()
      ) {
        case "aguardando":
        case "corrigido":
        case "redirecionado":
          return "aguardando-status";
        case "em andamento":
          return "andamento-status";
        case "aprovado":
          return "aprovado-status";
        case "retornado para correção":
          return "correcao-status";
        default:
          return "default-status";
      }
    },

    filterVlSolicitacao(item) {
      let sm = 0;
      for (let sol of item.solicitacoes_processo)
        sm += sol.quantidade * sol.vl_solicitacao;

      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(sm);
    },
    pagesPendencia() {
      const processos = this.processes.processosPendentes || [];
      return Math.ceil(processos.length / 10);
    },

    ...mapActions({
      listProvider: "$_process/index",
      getProcessTypes: "$_process/getProcessTypes",
      getProcessStatus: "$_process/getProcessStatus",
      getDepartaments: "$_process/getDepartaments"
    })
  }
};
</script>

<style lang="scss">
a[href="#anexo_da_nota_fiscal"].v-tab--active,
a[href="#anexo_da_nota_fiscal_retornado"].v-tab--active,
a[href="#pagamentos"].v-tab--active,
a[href="#finalizados"].v-tab--active,
a[href="#todos_os_processos"].v-tab--active,
a[href="#prestação_de_contas_retornado"].v-tab--active,
a[href="#prestação_de_contas"].v-tab--active {
  background: #1976d2 !important;
  color: #fff !important;
}

a[href="#anexo_da_nota_fiscal"],
a[href="#anexo_da_nota_fiscal_retornado"],
a[href="#pagamentos"],
a[href="#finalizados"],
a[href="#todos_os_processos"],
a[href="#prestação_de_contas_retornado"],
a[href="#prestação_de_contas"] {
  background: #4789ca !important;
  color: #fff !important;
}

.aguardando-status {
  background-color: #f6f4f4;

  .status {
    color: #039c4a;
  }
}
.andamento-status {
  background-color: #fef2c9;

  .status {
    color: #f39c12;
  }
}

.retornado-status {
  background-color: #f6f4f4;

  .status {
    color: black;
  }
}

.aprovado-status {
  background-color: #d0f6f9;

  .status {
    color: #039c4a;
  }
}

.correcao-status {
  background-color: #ffe9e8;

  .status {
    color: #e74c3c;
  }
}

.default-status {
  background-color: #f6f4f4;

  .status {
    color: black;
  }
}
</style>
